export default __webpack_public_path__ + "static/media/nofeedback.7f5a9e92.png";